import React, {Component} from "react";
import { Wizard } from 'react-use-wizard';
import {Row, Col} from "react-bootstrap";
import Card from "../../../components/Cards/Card/Card";
import KnoaBreadcrumb from "../../../components/Common/KnoaBreadcrumb";
import ProjectStep1 from "./ProjectStep1";
import ProjectStep2 from "./ProjectStep2";
import ProjectStep3 from "./ProjectStep3";
import {API} from "../../../lib/API";
import Footer from "../../../components/Footer/Footer";
import {Redirect} from "react-router-dom";
import moment from "moment";
import CommonContainer from "../../../components/Common/CommonContainer";
import {withTranslation} from 'react-i18next';
import {calculateStartDate, getServerTimezoneDate} from "../../../lib/common";
import Spinner from "../../../components/Common/Spinner";
import ModalDialog from "../../../components/Common/ModalDialog";
import {getSpecificOPErrorMessages} from "../../../lib/notifications/messageUtils";
import {notifyWithMessage} from "../../../lib/notifications/notifyWithMessage";
import {Helmet} from "react-helmet";

const localStorage = require('../../../lib/localStorage');

const fieldValidationRules = {
    annualFTECost: "numeric",
    annualFTEHours: "numeric",
    LTNonError: "numeric",
    LTSysError: "numeric",
    LTUserError: "numeric",
    LTUncatMessage: "numeric",
    projectDuration: "numeric",
    projectUser: "numeric",
    testEffortPerModule: "numeric",
    projectName: "requiredText"
};

class ProjectWizard extends Component {
    constructor(props) {
        super(props);

        this.handleSubmit = this.handleSubmit.bind(this);
        this.generateSelectOptions = this.generateSelectOptions.bind(this);
        this.handleProjectNameUpdate = this.handleProjectNameUpdate.bind(this);
        this.handleProjectTeamUpdate = this.handleProjectTeamUpdate.bind(this);
        this.handleUserAttributesUpdate = this.handleUserAttributesUpdate.bind(this);
        this.handleTimeFilterUpdate = this.handleTimeFilterUpdate.bind(this);
        this.handleProjectReportsUpdate = this.handleProjectReportsUpdate.bind(this);
        this.handleClickSave = this.handleClickSave.bind(this);
        this.formatDate = this.formatDate.bind(this);
        this.getPartOfDate = this.getPartOfDate.bind(this);
        this.validateTimeframe = this.validateTimeframe.bind(this);
        this.resetSelectAllCheckStatus = this.resetSelectAllCheckStatus.bind(this);
        this.validateNumericField = this.validateNumericField.bind(this);

        this.state = {
            projectName: "",
            projectTeam: [],
            application: "",
            userOptions: [],
            applicationOptions: [],
            applicationSelected: [],
            moduleOptions: [],
            moduleSelected: [],
            userAttributeFilters: [],
            timeFilter: {},
            workbooks: {},
            createdProjectId: -1,
            createdProjectName: "",
            formValid: false,
            preselectedReportID: this.props.location.state ? this.props.location.state.preSelectReportID : -1,
            updatedProjectId: this.props.location.state ? this.props.location.state.id : -1,
            absoluteStartErrorCurrent: null,
            absoluteEndErrorCurrent: null,
            absoluteStartErrorHistorical: null,
            absoluteEndErrorHistorical: null,
            redirect: false,
            fetchInProgress: "false",
            isSelectAllCheckedCurrent: false,
            isSelectAllCheckedHistorical: false,
            annualFTECost: {},
            annualFTEHours: {},
            LTNonError: {},
            LTSysError: {},
            LTUserError: {},
            LTUncatMessage: {},
            projectDuration: {},
            projectUser: {},
            testEffortPerModule: {},
            formErrors: {},
            inputClass_annualFTECost: 'form-control form-control-border-preferedpram',
            inputClass_annualFTEHours: 'form-control form-control-border-preferedpram',
            inputClass_LTNonError: 'form-control form-control-border-preferedpram',
            inputClass_LTSysError: 'form-control form-control-border-preferedpram',
            inputClass_LTUserError: 'form-control form-control-border-preferedpram',
            inputClass_LTUncatMessage: 'form-control form-control-border-preferedpram',
            inputClass_projectDuration: 'form-control form-control-border-preferedpram',
            inputClass_projectUser: 'form-control form-control-border-preferedpram',
            inputClass_testEffortPerModule: 'form-control form-control-border-preferedpram',
            inputClass_projectName: 'form-control form-control-border-preferedpram',
            showLoggedoutModal: false,
            sessionTerminated: false
        }
    };

    formatDate(date) {
        if (date)
            return date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear();
        else
            return ""
    }

    getPartOfDate(date, part) {
        if (part === "month") {
            return date.getMonth();
        } else if (part === "day") {
            return date.getDate();
        } else if (part === "year") {
            return date.getFullYear();
        } else return date;
    }

    handleLogoutConfirm = () => {
        this.setState({sessionTerminated: true});
    };


    handleSubmit() {
        let itemsToSubmit = {};
        let _this = this;
        let newProject = this.props.location.state.newProject;
        let projectURL;

        if (newProject) {
            projectURL = '/project/create';
        } else {
            projectURL = `/project/edit/${this.state.updatedProjectId}`
        }

        //applicationValueFilter
        itemsToSubmit.applicationValueFilter = this.state.applicationSelected.filter(x => x.selected === true).map(y => y.value);

        let timeFilterValue = "";
        //1 - ABSOLUTE - "mm/dd/yyyy-mm/dd/yyyy"
        //2 - BENCHMARK - "mm/dd/yyyy:<digit>" NO LONGER USED (MAUI-466)
        //3 - RELATIVE - "<digit>"

        //currentTimeFilter
        itemsToSubmit.currentTimeFilter = {};
        itemsToSubmit.currentTimeFilter.dataRange = "CURRENT";
        itemsToSubmit.currentTimeFilter.timeFilterId = this.state.timeFilter.current.selectedTimePeriodId;
        if (itemsToSubmit.currentTimeFilter.timeFilterId === 1) {
            timeFilterValue = this.formatDate(this.state.timeFilter.current.absoluteStartDate) + "-" + this.formatDate(this.state.timeFilter.current.EndDate);
        } else if (itemsToSubmit.currentTimeFilter.timeFilterId === 3) {
            timeFilterValue = this.state.timeFilter.current.relativeNew;
        }
        itemsToSubmit.currentTimeFilter.timeFilterValue = timeFilterValue.toString();

        //historicalTimeFilter
        itemsToSubmit.historicalTimeFilter = {};
        itemsToSubmit.historicalTimeFilter.dataRange = "HISTORICAL";
        itemsToSubmit.historicalTimeFilter.timeFilterId = this.state.timeFilter.historical.selectedTimePeriodId;
        timeFilterValue = "";
        if (itemsToSubmit.historicalTimeFilter.timeFilterId === 1) {
            timeFilterValue = this.formatDate(this.state.timeFilter.historical.absoluteStartDate) + "-" + this.formatDate(this.state.timeFilter.historical.EndDate);
        } else if (itemsToSubmit.historicalTimeFilter.timeFilterId === 3) {
            timeFilterValue = this.state.timeFilter.historical.relativeNew;
        }
        itemsToSubmit.historicalTimeFilter.timeFilterValue = timeFilterValue.toString();

        //moduleValueFilters
        itemsToSubmit.moduleValueFilters = this.state.moduleSelected.filter(x => x.selected === true).map(y => y.value);

        //name
        itemsToSubmit.name = this.state.projectName;

        //reports
        itemsToSubmit.reports = this.state.workbooks.currentSelectedProjects.concat(this.state.workbooks.historicalSelectedProjects);

        //team
        itemsToSubmit.team = this.state.projectTeam;

        //userAttributes
        let uaParam = [];
        let originaUAFilterValue = this.state.userAttributeFilters;
        originaUAFilterValue.forEach(att => {
            att.options.filter(v => v.selected === true).map(v => v.id).forEach(vv => uaParam.push(vv))
        });
        itemsToSubmit.userAttributes = uaParam;

        //itemsToSubmit.screenGroupFilter = this.state.screenGroupSelected.filter(x => x.selected === true).map(y => y.id);

        let tempTableauParameters = [];
        let latestannualFTECost = {};
        latestannualFTECost.name = this.state.annualFTECost.name;
        latestannualFTECost.value = this.state.annualFTECost.value;
        tempTableauParameters.push(latestannualFTECost);

        let latestannualFTEHours = {};
        latestannualFTEHours.name = this.state.annualFTEHours.name;
        latestannualFTEHours.value = this.state.annualFTEHours.value;
        tempTableauParameters.push(latestannualFTEHours);

        let latestLTNonError = {};
        latestLTNonError.name = this.state.LTNonError.name;
        latestLTNonError.value = this.state.LTNonError.value;
        tempTableauParameters.push(latestLTNonError);

        let latestLTSysError = {};
        latestLTSysError.name = this.state.LTSysError.name;
        latestLTSysError.value = this.state.LTSysError.value;
        tempTableauParameters.push(latestLTSysError);

        let latestLTUserError = {};
        latestLTUserError.name = this.state.LTUserError.name;
        latestLTUserError.value = this.state.LTUserError.value;
        tempTableauParameters.push(latestLTUserError);

        let latestLTUncatMessage = {};
        latestLTUncatMessage.name = this.state.LTUncatMessage.name;
        latestLTUncatMessage.value = this.state.LTUncatMessage.value;
        tempTableauParameters.push(latestLTUncatMessage);

        let latestprojectDuration = {};
        latestprojectDuration.name = this.state.projectDuration.name;
        latestprojectDuration.value = this.state.projectDuration.value;
        tempTableauParameters.push(latestprojectDuration);

        let latestprojectUser = {};
        latestprojectUser.name = this.state.projectUser.name;
        latestprojectUser.value = this.state.projectUser.value;
        tempTableauParameters.push(latestprojectUser);

        let latesttestEffortPerModule = {};
        latesttestEffortPerModule.name = this.state.testEffortPerModule.name;
        latesttestEffortPerModule.value = this.state.testEffortPerModule.value;
        tempTableauParameters.push(latesttestEffortPerModule);

        itemsToSubmit.tableauParameters = tempTableauParameters;

        this.setState({fetchInProgress: "true"});

        API.project
            .post(projectURL, itemsToSubmit)
            .then(resp => {
                const {data: resData} = resp;
                const {data} = resData;

                let inSupport = resData ? resData.inSupport : false;

                if (newProject) {
                    console.log(`Project with id ${data.projectId} is created! \n` +
                        JSON.stringify(itemsToSubmit)
                    );
                    notifyWithMessage({type: "success", t: this.props.t, operation: "changeSaved", parameter: "Project", inSupport});
                    _this.setState({
                        createdProjectId: data.projectId,
                        createdProjectName: itemsToSubmit.name,
                        formValid: true,
                        absoluteStartErrorCurrent: null,
                        absoluteEndErrorCurrent: null,
                        absoluteStartErrorHistorical: null,
                        absoluteEndErrorHistorical: null,
                        fetchInProgress: localStorage.get("isLoading")
                    });
                } else {
                    //Reset filters for this project reports
                    window.sessionStorage.removeItem('reportProject' + _this.state.updatedProjectId);

                    console.log(`Project with id ${_this.state.updatedProjectId} is updated! \n` +
                        JSON.stringify(itemsToSubmit)
                    );
                    notifyWithMessage({type: "success", t: this.props.t, operation: "changeSaved", parameter: "Project", inSupport});
                    _this.setState({
                        formValid: true,
                        absoluteStartErrorCurrent: null,
                        absoluteEndErrorCurrent: null,
                        absoluteStartErrorHistorical: null,
                        absoluteEndErrorHistorical: null,
                        fetchInProgress: localStorage.get("isLoading")
                    });
                }
            })
            .catch(e => {
                console.error(e);
                this.setState({fetchInProgress: localStorage.get("isLoading")});
                if (localStorage.get("accessDenied401") === "true") {
                    this.setState({showLoggedoutModal: true});
                    return;
                }

                let resultCode = -1;
                let resultData = "";

                if (e.data) {
                    const {data: resData} = e;
                    const {data} = resData;
                    resultCode = data.resultCode;
                    resultData = data.data;
                }

                if (e.status === 401 || resultCode === 6007)
                    window.location.href = "/#/auth/logout"

                if (resultData === "PROJECT_EXISTS_WITH_SAME_NAME") {
                    const formErrors = {
                        ...this.state.formErrors,
                        projectName: this.props.t("validation:duplicateProjectName")
                    };

                    this.setState({
                        formErrors,
                        inputClass_projectName: "form-control form-validation-input-error",
                        formValid: false
                    });
                    notifyWithMessage({type: "error", t: this.props.t, operation: "projectNameIssue", parameter: "Project", resultCode: null});
                } else if (resultCode > -1) {
                    notifyWithMessage({type: 'error', t: this.props.t, resultCode, isNormal: true});
                } else {
                    notifyWithMessage({type: 'error', t: this.props.t, errorObject: e, isNormal: true});
                }
            });
    }

    componentDidMount() {
        if (!this.props.location.state) {
            this.setState({redirect: true});
            return;
        }

        let _this = this;
        let projectURL;
        let newProject = this.props.location.state.newProject;

        //New Project
        if (newProject) {
            projectURL = "/project/v2/view/create";

            if (this.state.preselectedReportID >= 0) {
                projectURL = projectURL + "/" + this.state.preselectedReportID;
                console.log("Pre-selected report ID: " + this.state.preselectedReportID);
            }
        }
        //Edit Project
        else {
            projectURL = `/project/v2/view/edit/${this.state.updatedProjectId}`
        }

        API.project
            .get(projectURL)
            .then(resp => {
                const {data: resData} = resp;
                const {data} = resData;

                let projectName = "";
                if (!newProject) {
                    //Project Name
                    projectName = data.name;
                }

                //Project Team dropdown
                const userOptions = _this.generateSelectOptions(data.users, "userName", "userId");
                let team = [];
                if (!newProject) {
                    team = data.team.map(user => {
                        return user.userId.toString();
                    });
                }

                //Time filters
                const timeFilter = {};
                timeFilter.current = {};
                timeFilter.historical = {};
                //selected timeframe option - current
                timeFilter.current.selectedTimePeriod = data.currentAnalysis.timeFilters.timeFilterOptions.filter(item => item.selected)[0].timePeriod;
                timeFilter.current.selectedTimePeriodId = data.currentAnalysis.timeFilters.timeFilterOptions.filter(item => item.selected)[0].id;
                timeFilter.current.timePeriodInfo = data.currentAnalysis.timeFilters.timeFilterOptions.map(item => {
                    return ({
                        "id": item.id,
                        "name": item.timePeriod
                    })
                });
                //selected timeframe option - current
                timeFilter.historical.selectedTimePeriod = data.historicalAnalysis.timeFilters.timeFilterOptions.filter(item => item.selected)[0].timePeriod;
                timeFilter.historical.selectedTimePeriodId = data.historicalAnalysis.timeFilters.timeFilterOptions.filter(item => item.selected)[0].id;
                timeFilter.historical.timePeriodInfo = data.historicalAnalysis.timeFilters.timeFilterOptions.map(item => {
                    return ({
                        "id": item.id,
                        "name": item.timePeriod
                    })
                });
                //limit
                timeFilter.current.limit = data.currentAnalysis.timeFilters.timeRangeLimit;
                timeFilter.historical.limit = data.historicalAnalysis.timeFilters.timeRangeLimit;

                //relative from preferences and updated
                const currentRelativePref = data.currentAnalysis.timeFilters.defaultTimeRangeValue;
                const historicalRelativePref = data.historicalAnalysis.timeFilters.defaultTimeRangeValue;
                if (!newProject) {
                    if (timeFilter.current.selectedTimePeriod === "RELATIVE") {
                        timeFilter.current.relativeNew = data.currentTimeFilter.timeFilterValue;
                    } else {
                        timeFilter.current.relativeNew = currentRelativePref;
                    }

                    if (timeFilter.historical.selectedTimePeriod === "RELATIVE") {
                        timeFilter.historical.relativeNew = data.historicalTimeFilter.timeFilterValue;
                    } else {
                        timeFilter.historical.relativeNew = historicalRelativePref;
                    }
                } else {
                    timeFilter.current.relativeNew = currentRelativePref;
                    timeFilter.historical.relativeNew = historicalRelativePref;
                }

                //date calculation - current start/end (including today)
                if (newProject || timeFilter.current.selectedTimePeriod === "RELATIVE") {
                    timeFilter.current.absoluteStartDate = calculateStartDate("CURRENT", currentRelativePref, null);
                    timeFilter.current.EndDate = getServerTimezoneDate();
                } else if (timeFilter.current.selectedTimePeriod === "ABSOLUTE") {
                    let absoluteDates = data.currentTimeFilter.timeFilterValue.split('-');
                    timeFilter.current.absoluteStartDate = new Date(absoluteDates[0]);
                    timeFilter.current.EndDate = new Date(absoluteDates[1]);
                }
                timeFilter.current.absoluteCalendarStart = calculateStartDate("CURRENT", timeFilter.current.limit, null);

                //date calculation - historical start/end
                if (newProject || timeFilter.historical.selectedTimePeriod === "RELATIVE") {
                    timeFilter.historical.absoluteStartDate = calculateStartDate("HISTORICAL", historicalRelativePref, null);
                    timeFilter.historical.EndDate = getServerTimezoneDate();
                } else if (timeFilter.historical.selectedTimePeriod === "ABSOLUTE") {
                    let absoluteDates = data.historicalTimeFilter.timeFilterValue.split('-');
                    timeFilter.historical.absoluteStartDate = new Date(absoluteDates[0]);
                    timeFilter.historical.EndDate = new Date(absoluteDates[1]);
                }
                timeFilter.historical.absoluteCalendarStart = calculateStartDate("HISTORICAL", timeFilter.historical.limit, null);

                //Report information
                const workbooks = {};
                workbooks.currentReportArray = data.currentAnalysis.reportCategories.map(key => {
                    return {
                        type: key.categoryName,
                        data: key.workbooks,
                        icon: key.icon
                    }
                });
                workbooks.historicalReportArray = data.historicalAnalysis.reportCategories.map(key => {
                    return {
                        type: key.categoryName,
                        data: key.workbooks,
                        icon: key.icon
                    }
                });

                workbooks.currentSelectedProjects = [];
                workbooks.currentReportArray.map(report => {
                    report.data.map(type => {
                        if (type.id === this.state.preselectedReportID || type.selected === true) {
                            type.checked = true;
                            workbooks.currentSelectedProjects.push(type.id);
                        } else {
                            type.checked = false;
                        }
                    });
                });
                workbooks.historicalSelectedProjects = [];
                workbooks.historicalReportArray.map(report => {
                    report.data.map(type => {
                        if (type.id === this.state.preselectedReportID || type.selected === true) {
                            type.checked = true;
                            workbooks.historicalSelectedProjects.push(type.id);
                        } else {
                            type.checked = false;
                        }
                    });
                });

                //add label to filter options
                Object.entries(data.contextFilterOptions).forEach(filter => {
                    if (filter[0] === 'applicationFilters' || filter[0] === 'moduleFilters') { //|| filter[0]==='screenGroupFilters'
                        if (filter[1] && filter[1].length > 0) {
                            filter[1].map(option => {
                                option.label = option.value;
                            });
                        }
                    }
                });

                _this.setState({
                    projectName: projectName,
                    projectTeam: team,
                    userOptions: userOptions,
                    applicationOptions: data.contextFilterOptions.applicationFilters,
                    applicationSelected: data.contextFilterOptions.applicationFilters,
                    ModuleOptions: data.contextFilterOptions.moduleFilters,
                    moduleSelected: data.contextFilterOptions.moduleFilters,
                    //screenGroupOptions: data.contextFilterOptions.screenGroupFilters,
                    //screenGroupSelected: data.contextFilterOptions.screenGroupFilters,
                    userAttributeFilters: data.contextFilterOptions.userAttributes,
                    timeFilter: timeFilter,
                    workbooks: workbooks,
                    annualFTECost: data.tableauParams.filter(param => param.name === "Annual FTE Cost (currency)")[0],
                    annualFTEHours: data.tableauParams.filter(param => param.name === "Annual FTE hours")[0],
                    LTNonError: data.tableauParams.filter(param => param.name === "Lost time due to non errors (seconds)")[0],
                    LTSysError: data.tableauParams.filter(param => param.name === "Lost time due to system errors (seconds)")[0],
                    LTUserError: data.tableauParams.filter(param => param.name === "Lost time due to user errors (seconds)")[0],
                    LTUncatMessage: data.tableauParams.filter(param => param.name === "Lost Time Due to Uncategorized Messages (seconds)")[0],
                    projectDuration: data.tableauParams.filter(param => param.name === "Projected Duration (years)")[0],
                    projectUser: data.tableauParams.filter(param => param.name === "Projected Users")[0],
                    testEffortPerModule: data.tableauParams.filter(param => param.name === "Testing effort per module (hours)")[0],
                });
            })
            .catch(e => {
                // only log error for now
                console.error(e);
                _this.setState({redirect: true});
                if (localStorage.get("accessDenied401") === "true") {
                    this.setState({showLoggedoutModal: true});
                    return;
                }
                let resultCode = -1;
                if (e.data) {
                    resultCode = e.data.resultCode;
                }
                if (resultCode > -1) {
                    notifyWithMessage({type: 'error', t: this.props.t, resultCode, isNormal: true});
                } else {
                    notifyWithMessage({type: 'error', t: this.props.t, errorObject: e, isNormal: true});
                }
            });
    }

    generateSelectOptions(data, _label, _value) {
        return data.map(key => {
            return {
                id: key.userId,
                label: key[_label],
                value: key[_value]===undefined? "": key[_value].toString(),
                checked: key.selected ? key.selected : false,
                // options: key.options ? key.options : undefined  //remove for react-select latest version wont accept unuseful undefined field here
            }
        });
    }

    handleProjectNameUpdate(input) {
        const trimmedValue = input?.trim() ?? "";
        const errorMessage = trimmedValue === ""
            ? this.props.t('validation:fieldRequired', { field: 'projectName' })
            : null;

        this.setState({
            projectName: trimmedValue,
            formErrors: {
                ...this.state.formErrors,
                projectName: errorMessage
            },
            inputClass_projectName: errorMessage
                ? "form-control form-validation-input-error"
                : "form-control form-control-border-preferedpram"
        });
    }

    handleProjectTeamUpdate(input) {
        this.setState({
            projectTeam: input
        });
    }

    handleApplicationsOnChange = (event) => {
        let selectedOptionsLength = event.length;
        let selectedApplications = this.state.applicationSelected;
        if (selectedOptionsLength > selectedApplications.length) {
            let newOptions = {
                id: event[selectedOptionsLength - 1].id,
                value: event[selectedOptionsLength - 1].value,
                label: event[selectedOptionsLength - 1].label,
                selected: true
            };
            selectedApplications.push(newOptions);
        } else {
            selectedApplications = event;
        }

        this.setState({applicationSelected: selectedApplications});
    };

    handleApplicationsInputChange = (event) => {
        if (event === "") return;
        // passing 0 as workbook id to indicates that this request is not report specific
        API.report
            .post('/report/list/application/0?top=100', {
                word: event
            })
            .then(resp => {
                const {data: resData} = resp;
                const {data} = resData;

                let latestOptions = data.results;

                //add label
                latestOptions.map(item => {
                    item.label = item.value;
                });

                this.setState({applicationOptions: latestOptions});
            })
            .catch(e => {
                console.error(e);
                if (localStorage.get("accessDenied401") === "true") {
                    this.setState({showLoggedoutModal: true});
                    return;
                }
                let resultCode = -1;
                if (e.data) {
                    resultCode = e.data.resultCode;
                }
                if (e.status === 401 || resultCode === 6007)
                    window.location.href = "/#/auth/logout"

                if (resultCode > -1) {
                    notifyWithMessage({type: 'error', t: this.props.t, resultCode, isNormal: true});
                } else {
                    notifyWithMessage({type: 'error', t: this.props.t, errorObject: e, isNormal: true});
                }
            });
    };

    handleModulesOnChange = (event) => {
        let selectedOptionsLength = event.length;
        let selectedModules = this.state.moduleSelected;
        if (selectedOptionsLength > selectedModules.length) {
            let newOptions = {
                id: event[selectedOptionsLength - 1].id,
                value: event[selectedOptionsLength - 1].value,
                label: event[selectedOptionsLength - 1].label,
                selected: true
            };
            selectedModules.push(newOptions);
        } else {
            selectedModules = event;
        }

        this.setState({moduleSelected: selectedModules});
    };

    handleModulesInputChange = (event) => {
        if (event === "") return;
        // passing 0 as workbook id to indicates that this request is not report specific
        API.report
            .post('/report/list/module/0?top=100', {
                word: event
            })
            .then(resp => {
                const {data: resData} = resp;
                const {data} = resData;

                let latestOptions = data.results;

                //add label
                latestOptions.map(item => {
                    item.label = item.value;
                });

                this.setState({moduleOptions: latestOptions});
            })
            .catch(e => {
                console.error(e);
                if (localStorage.get("accessDenied401") === "true") {
                    this.setState({showLoggedoutModal: true});
                    return;
                }
                let resultCode = -1;
                if (e.data) {
                    resultCode = e.data.resultCode;
                }
                if (e.status === 401 || resultCode === 6007)
                    window.location.href = "/#/auth/logout"

                if (resultCode > -1) {
                    notifyWithMessage({type: 'error', t: this.props.t, resultCode, isNormal: true});
                } else {
                    notifyWithMessage({type: 'error', t: this.props.t, errorObject: e, isNormal: true});
                }
            });
    };

    handleUserAttributesUpdate(selectedOptions, id) {
        console.log("parent handle was called for attribute ID: " + id);
        let selectedListLength = selectedOptions.length;
        let currentUAObj = this.state.userAttributeFilters.filter(ua => ua.id === id);
        let currentUAOptions = currentUAObj[0].options;
        let originalOptions = (currentUAOptions === null || currentUAOptions === undefined || currentUAObj.length === 0) ? [] : currentUAOptions.filter(x => x.selected === true);

        if (selectedListLength > originalOptions.length) {
            let newlySelected = {
                id: selectedOptions[selectedListLength - 1].id,
                value: selectedOptions[selectedListLength - 1].value,
                selected: true
            };
            if (originalOptions.filter(x => x.id === selectedOptions[selectedListLength - 1].id).length > 0) {
                originalOptions.map(op => op.id === selectedOptions[selectedListLength - 1].id ? newlySelected : op)
            } else
                originalOptions.push(newlySelected);
        } else {
            originalOptions = selectedOptions;
        }

        let tempAllUAs = this.state.userAttributeFilters;
        tempAllUAs.forEach(ua => {
            if (ua.id === id) ua.options = originalOptions
        });
        this.setState({userAttributeFilters: tempAllUAs});
    }

    handleTimeFilterUpdate(type, dataRange, value) {
        const timeFilter = this.state.timeFilter;

        if (type === "radioTimeframeOptions") {
            if (dataRange === "Current") {
                timeFilter.current.selectedTimePeriod = value;
                timeFilter.current.selectedTimePeriodId = timeFilter.current.timePeriodInfo.filter(item => item.name === value)[0].id;
            } else if (dataRange === "Historical") {
                timeFilter.historical.selectedTimePeriod = value;
                timeFilter.historical.selectedTimePeriodId = timeFilter.historical.timePeriodInfo.filter(item => item.name === value)[0].id;
            }
        } else if (type === "relativeSlider") {
            if (dataRange === "Current") {
                timeFilter.current.relativeNew = value;
            } else if (dataRange === "Historical") {
                timeFilter.historical.relativeNew = value;
            }
        } else if (type === "absoluteStartDate") {
            if (typeof (value) === "string") {
                if (dataRange === "Current") {
                    timeFilter.current.absoluteStartDate = value;
                } else if (dataRange === "Historical") {
                    timeFilter.historical.absoluteStartDate = value;
                }
            } else {
                const startDate = value.toDate();
                if (dataRange === "Current") {
                    timeFilter.current.absoluteStartDate = startDate;
                    if (timeFilter.current.EndDate < timeFilter.current.absoluteStartDate) {
                        timeFilter.current.EndDate = value.toDate();
                    }
                } else if (dataRange === "Historical") {
                    startDate.setDate(1);
                    timeFilter.historical.absoluteStartDate = startDate;
                    if (timeFilter.historical.EndDate < timeFilter.historical.absoluteStartDate) {
                        timeFilter.historical.EndDate = value.toDate();
                    }
                }
            }
        } else if (type === "absoluteEndDate") {
            if (typeof (value) === "string") {
                if (dataRange === "Current") {
                    timeFilter.current.EndDate = value;
                } else if (dataRange === "Historical") {
                    timeFilter.historical.EndDate = value;
                }
            } else {
                if (dataRange === "Current") {
                    timeFilter.current.EndDate = value.toDate();
                } else if (dataRange === "Historical") {
                    timeFilter.historical.EndDate = value.toDate();
                }
            }
        }

        this.setState({timeFilter: timeFilter});
    }

    handleProjectReportsUpdate(label, isChecked) {
        const info = label.split(':');
        let workbooks = this.state.workbooks;
        let pr = [];
        let selectedProjects = [];

        if (info[2] === "CURRENT") {
            pr = workbooks.currentReportArray;
            selectedProjects = workbooks.currentSelectedProjects;
        } else if (info[2] === "HISTORICAL") {
            pr = workbooks.historicalReportArray;
            selectedProjects = workbooks.historicalSelectedProjects;
        }

        pr = pr.map((project) => {
            let data = project.data;
            data.map((item) => {
                if (item.id.toString() === info[1]) {
                    item.checked = isChecked;
                    if (isChecked && selectedProjects.indexOf(item.id) === -1) {
                        selectedProjects.push(item.id);
                    } else if (!isChecked && selectedProjects.indexOf(item.id) !== -1) {
                        let index = selectedProjects.indexOf(item.id);
                        if (index > -1) {
                            selectedProjects.splice(index, 1);
                        }
                    }
                }
                return item;
            });
            return project;
        });

        let currentTypeReports = pr.filter(x => x.type === info[0]);
        let currentTypeReportsData = currentTypeReports[0].data;
        let numberOfUnselected = currentTypeReportsData.filter(y => y.checked === false).length;

        const stateUpdate = {
            workbooks: workbooks
        };

        if(info[2] === "CURRENT") {
            stateUpdate.isSelectAllCheckedCurrent = numberOfUnselected <= 0;
        } else if(info[2] === "HISTORICAL") {
            stateUpdate.isSelectAllCheckedHistorical = numberOfUnselected <= 0;
        }

        this.setState(stateUpdate);
    }

    handleInputChange = (fieldKey, newValue) => {
        const tempField = { ...this.state[fieldKey], value: newValue };
        const rule = fieldValidationRules[fieldKey];
        let error = null;

        if (rule === "numeric") {
            error = this.validateNumericField(tempField, this.props.t);
        } else if (rule === "requiredText") {
            error = newValue.trim() === "" ? { message: "This field is required." } : null;
        }

        this.setState({
            [fieldKey]: tempField,
            formErrors: {
                ...this.state.formErrors,
                [fieldKey]: error ? error.message : null
            },
            ['inputClass_' + fieldKey]: error
                ? 'form-control form-validation-input-error'
                : 'form-control form-control-border-preferedpram'
        });
    };

    selectAllHandler = (reportType, checked, tabKey) => {
        console.log(reportType + "   " + tabKey);

        const selectAllKey = reportType === "CURRENT"
            ? "isSelectAllCheckedCurrent"
            : reportType === "HISTORICAL"
            ? "isSelectAllCheckedHistorical"
            : null;
        if(selectAllKey) {
            this.setState({[selectAllKey]: checked});
        }

        let workbooks = this.state.workbooks;

        let pr = [];
        let selectedProjects = [];

        if (reportType === "CURRENT") {
            pr = workbooks.currentReportArray;
            selectedProjects = workbooks.currentSelectedProjects;
        } else if (reportType === "HISTORICAL") {
            pr = workbooks.historicalReportArray;
            selectedProjects = workbooks.historicalSelectedProjects;
        }

        pr.map((project) => {
            if (project.type === tabKey) {
                let data = project.data;
                data.map((item) => {
                    item.checked = checked;
                    if (selectedProjects.indexOf(item.id) === -1) {
                        selectedProjects.push(item.id);
                    } else if (!checked && selectedProjects.indexOf(item.id) !== -1) {
                        let index = selectedProjects.indexOf(item.id);
                        if (index > -1) {
                            selectedProjects.splice(index, 1);
                        }
                    }
                    return item;
                });
                return project;
            }
        });

        this.setState({
            workbooks: workbooks
        })
    };

    resetSelectAllCheckStatus = (reportType, tabKey) => {
        let workbooks = this.state.workbooks;
        let pr = [];
        let selectAllKey;

        if (reportType === "CURRENT") {
            pr = workbooks.currentReportArray;
            selectAllKey = "isSelectAllCheckedCurrent";
        } else if (reportType === "HISTORICAL") {
            pr = workbooks.historicalReportArray;
            selectAllKey = "isSelectAllCheckedHistorical";
        }

        if(selectAllKey) {
            let currentTabPr = pr.filter(p => p.type === tabKey);
            let allReportsUnderThisTab = currentTabPr[0].data;
            let selectedNOofReports = allReportsUnderThisTab.filter(x => x.checked === true);
            if (allReportsUnderThisTab.length > 0 && allReportsUnderThisTab.length === selectedNOofReports.length)
                this.setState({[selectAllKey]: true});
            else
                this.setState({[selectAllKey]: false});
        }
    };

    resetOptions = (event, filterName) => {
        switch (filterName) {
            case "application": {
                this.setState({applicationOptions: []});
                break;
            }
            case "module": {
                this.setState({moduleOptions: []});
                break;
            }
            default: {
                console.warn("no match filter callback method .")
            }
        }
    };

    validateTimeframe(type) {
        let timeFilter = {};
        let ASErrorFound = false;
        let AEErrorFound = false;
        let dateFormat = "";

        if (type === "Current") {
            timeFilter = this.state.timeFilter.current;
            dateFormat = "MM/DD/YYYY";
        } else if (type === "Historical") {
            timeFilter = this.state.timeFilter.historical;
            dateFormat = "MM/YYYY";
        }

        if (timeFilter.selectedTimePeriod === "ABSOLUTE") {
            if (typeof (timeFilter.absoluteStartDate) === "string" || typeof (timeFilter.EndDate) === 'string') {
                if (typeof (timeFilter.absoluteStartDate) === "string") {
                    if (type === "Current") {
                        this.setState({
                            absoluteStartErrorCurrent: (<small className="text-danger">{this.props.t('validation:invalidDate')}</small>)
                        });
                    } else if (type === "Historical") {
                        this.setState({
                            absoluteStartErrorHistorical: (<small className="text-danger">{this.props.t('validation:invalidDate')}</small>)
                        });
                    }
                    ASErrorFound = true;
                }
                if (typeof (timeFilter.EndDate) === 'string') {
                    if (type === "Current") {
                        this.setState({
                            absoluteEndErrorCurrent: (<small className="text-danger">{this.props.t('validation:invalidDate')}</small>)
                        });
                    } else if (type === "Historical") {
                        this.setState({
                            absoluteEndErrorHistorical: (<small className="text-danger">{this.props.t('validation:invalidDate')}</small>)
                        });
                    }
                    AEErrorFound = true;
                }
            } else {
                const startDateAbsolute = document.getElementById('startDateAbsolute' + type);
                const endDateAbsolute = document.getElementById('endDateAbsolute' + type);

                if (startDateAbsolute && endDateAbsolute) {
                    let startDate = new Date(this.getPartOfDate(timeFilter.absoluteCalendarStart, "year"),
                        this.getPartOfDate(timeFilter.absoluteCalendarStart, "month"),
                        this.getPartOfDate(timeFilter.absoluteCalendarStart, "day"), 0, 0, 0
                    );
                    let endDate = new Date(this.getPartOfDate(timeFilter.absoluteStartDate, "year"),
                        this.getPartOfDate(timeFilter.absoluteStartDate, "month"),
                        this.getPartOfDate(timeFilter.absoluteStartDate, "day"), 0, 0, 0
                    );

                    let absoluteStartDateValue = {};
                    let absoluteEndDateValue = {};

                    if (type === "Current") {
                        absoluteStartDateValue = new Date(startDateAbsolute.value);
                        absoluteEndDateValue = new Date(endDateAbsolute.value);
                    } else if (type === "Historical") {
                        absoluteStartDateValue = new Date(startDateAbsolute.value.slice(0, 3) + "01" + startDateAbsolute.value.slice(2));
                        absoluteEndDateValue = new Date(endDateAbsolute.value.slice(0, 3) + "01" + endDateAbsolute.value.slice(2));
                    }

                    if (!moment(startDateAbsolute.value, dateFormat, true).isValid()) {
                        if (type === "Current") {
                            this.setState({
                                absoluteStartErrorCurrent: (<small className="text-danger">{this.props.t('validation:invalidDate')}</small>)
                            });
                        } else if (type === "Historical") {
                            this.setState({
                                absoluteStartErrorHistorical: (
                                    <small className="text-danger">{this.props.t('validation:invalidDate')}</small>)
                            });
                        }
                        ASErrorFound = true;
                    } else if (absoluteStartDateValue.valueOf() > 0) {
                        if (startDate.valueOf() > 0 && absoluteStartDateValue.valueOf() < startDate.valueOf()) {
                            if (type === "Current") {
                                this.setState({
                                    absoluteStartErrorCurrent: (
                                        <small className="text-danger">{this.props.t('validation:dateOutOfRange')}</small>)
                                });
                            } else if (type === "Historical") {
                                this.setState({
                                    absoluteStartErrorHistorical: (
                                        <small className="text-danger">{this.props.t('validation:dateOutOfRange')}</small>)
                                });
                            }
                            ASErrorFound = true;
                        }
                    } else {
                        if (type === "Current") {
                            this.setState({
                                absoluteStartErrorCurrent: (<small className="text-danger">{this.props.t('validation:invalidDate')}</small>)
                            });
                        } else if (type === "Historical") {
                            this.setState({
                                absoluteStartErrorHistorical: (
                                    <small className="text-danger">{this.props.t('validation:invalidDate')}</small>)
                            });
                        }
                        ASErrorFound = true;
                    }

                    if (!moment(endDateAbsolute.value, dateFormat, true).isValid()) {
                        if (type === "Current") {
                            this.setState({
                                absoluteEndErrorCurrent: (<small className="text-danger">{this.props.t('validation:invalidDate')}</small>)
                            });
                        } else if (type === "Historical") {
                            this.setState({
                                absoluteEndErrorHistorical: (
                                    <small className="text-danger">{this.props.t('validation:invalidDate')}</small>)
                            });
                        }
                        AEErrorFound = true;
                    } else if (absoluteEndDateValue.valueOf() > 0) {
                        if (endDate.valueOf() > 0 && absoluteEndDateValue.valueOf() < endDate.valueOf()) {
                            if (type === "Current") {
                                this.setState({
                                    absoluteEndErrorCurrent: (
                                        <small className="text-danger">{this.props.t('validation:dateEndBeforeStart')}</small>)
                                });
                            } else if (type === "Historical") {
                                this.setState({
                                    absoluteEndErrorHistorical: (
                                        <small className="text-danger">{this.props.t('validation:dateEndBeforeStart')}</small>)
                                });
                            }
                            AEErrorFound = true;
                        }
                    } else {
                        if (type === "Current") {
                            this.setState({
                                absoluteEndErrorCurrent: (<small className="text-danger">{this.props.t('validation:invalidDate')}</small>)
                            });
                        } else if (type === "Historical") {
                            this.setState({
                                absoluteEndErrorHistorical: (
                                    <small className="text-danger">{this.props.t('validation:invalidDate')}</small>)
                            });
                        }
                        AEErrorFound = true;
                    }
                }
            }
        }

        if (ASErrorFound || AEErrorFound) {
            if (!ASErrorFound) {
                if (type === "Current") {
                    this.setState({absoluteStartErrorCurrent: null});
                } else if (type === "Historical") {
                    this.setState({absoluteStartErrorHistorical: null});
                }
            }
            if (!AEErrorFound) {
                if (type === "Current") {
                    this.setState({absoluteEndErrorCurrent: null});
                } else if (type === "Historical") {
                    this.setState({absoluteEndErrorHistorical: null});
                }
            }
            return false;
        } else {
            if (type === "Current") {
                this.setState({
                    absoluteStartErrorCurrent: null,
                    absoluteEndErrorCurrent: null
                });
            } else if (type === "Historical") {
                this.setState({
                    absoluteStartErrorHistorical: null,
                    absoluteEndErrorHistorical: null
                });
            }
            return true;
        }
    }

    getNameforStyles = (orignalFieldName) => {
        if (orignalFieldName === undefined) return "undefined";
        let orignalName = orignalFieldName.toString();
        let covertedName = "";

        if (orignalName.includes("Annual FTE Cost"))
            covertedName = "annualFTECost";
        else if (orignalName.includes("Annual FTE hours"))
            covertedName = "annualFTEHours";
        else if (orignalName.includes("Lost time due to non errors"))
            covertedName = "LTNonError";
        else if (orignalName.includes("Lost time due to system errors"))
            covertedName = "LTSysError";
        else if (orignalName.includes("Lost time due to user errors"))
            covertedName = "LTUserError";
        else if (orignalName.includes("Lost Time Due to Uncategorized Messages"))
            covertedName = "LTUncatMessage";
        else if (orignalName.includes("Projected Duration"))
            covertedName = "projectDuration";
        else if (orignalName.includes("Projected Users"))
            covertedName = "projectUser";
        else if (orignalName.includes("Testing effort per module"))
            covertedName = "testEffortPerModule";

        return covertedName;
    };

    validateNumericField(paramObj, t) {
        const value = paramObj.value;
        const fieldName = this.getNameforStyles(paramObj.name);
        const num = Number(value);

        if (value === "") {
            return { field: fieldName, message: t('validation:emptyValue') };
        }
        if (isNaN(num)) {
            return { field: fieldName, message: t('validation:number') };
        }
        if (value.startsWith("-") || num < 0) {
            return { field: fieldName, message: t('validation:numberLess', { input: "0" }) };
        }
        if (value.length > 1 && value.charAt(0) === '0') {
            return { field: fieldName, message: t('validation:numberZero') };
        }

        const limits = {
            annualFTECost: 1000000,
            annualFTEHours: 10000,
            LTNonError: 100000,
            LTSysError: 100000,
            LTUserError: 100000,
            LTUncatMessage: 100000,
            projectDuration: 100,
            projectUser: 1000000,
            testEffortPerModule: 1000
        };

        if (limits[fieldName] !== undefined && num > limits[fieldName]) {
            return { field: fieldName, message: t('validation:numberMore', { input: limits[fieldName].toString() }) };
        }

        return null;
    }

    handleClickSave() {
        let isValidProjectName = true;
        let isValidCurrentTimeframe;
        let isValidHistoricalTimeframe;

        const formErrors = { ...this.state.formErrors };

        // Project name validation
        const trimmedProjectName = this.state.projectName?.trim() ?? "";
        if (trimmedProjectName === "") {
            formErrors.projectName = this.props.t('validation:fieldRequired', { field: 'projectName' });
            isValidProjectName = false;
        } else {
            formErrors.projectName = null;
        }

        //Timeframe validation
        isValidCurrentTimeframe = this.validateTimeframe("Current");
        isValidHistoricalTimeframe = this.validateTimeframe("Historical");

        // Preferred parameters validation
        const preferredParams = [
            this.state.annualFTECost,
            this.state.annualFTEHours,
            this.state.LTNonError,
            this.state.LTSysError,
            this.state.LTUserError,
            this.state.LTUncatMessage,
            this.state.projectDuration,
            this.state.projectUser,
            this.state.testEffortPerModule
        ];

        const thresholds = {
            annualFTECost: 1000000,
            annualFTEHours: 10000,
            LTNonError: 100000,
            LTSysError: 100000,
            LTUserError: 100000,
            LTUncatMessage: 100000,
            projectDuration: 100,
            projectUser: 1000000,
            testEffortPerModule: 1000
        };

        preferredParams.forEach(paramObj => {
            if (!paramObj || typeof paramObj.value === 'undefined') return;

            const value = paramObj.value;
            const fieldName = this.getNameforStyles(paramObj.name);

            if (isNaN(value)) {
                formErrors[fieldName] = this.props.t('validation:number');
            } else if ((value !== null && value.startsWith("-")) || Number(value) < 0) {
                formErrors[fieldName] = this.props.t('validation:numberLess', { input: "0" });
            } else if (value !== null && value.length > 1 && value.charAt(0) === '0') {
                formErrors[fieldName] = this.props.t('validation:numberZero');
            } else if (value === "") {
                formErrors[fieldName] = this.props.t('validation:emptyValue');
            } else if (Number(value) > 0) {
                const max = thresholds[fieldName];
                if (max && Number(value) > max) {
                    formErrors[fieldName] = this.props.t('validation:numberMore', { input: max.toString() });
                } else {
                    formErrors[fieldName] = null;
                }
            } else {
                formErrors[fieldName] = null;
            }
        });

        const allFields = [
            "annualFTECost",
            "annualFTEHours",
            "LTNonError",
            "LTSysError",
            "LTUserError",
            "LTUncatMessage",
            "projectDuration",
            "projectUser",
            "testEffortPerModule",
            "projectName"
        ];

        const inputClasses = {};
        allFields.forEach((field) => {
            inputClasses["inputClass_" + field] = formErrors[field]
                ? "form-control form-validation-input-error"
                : "form-control form-control-border-preferedpram";
        });

        if (isValidProjectName && isValidCurrentTimeframe && isValidHistoricalTimeframe && !Object.values(formErrors).some(msg => msg)) {
            this.handleSubmit();
            this.setState({
                formErrors: {},
                ...inputClasses
            });
        } else {
            this.setState({
                formErrors,
                ...inputClasses
            });
            notifyWithMessage({type: "error", t: this.props.t, operation: "validationErrorMessage", parameter: null, resultCode: null});
        }
    }

    render() {
        const { t } = this.props;
        const newProject = this.props.location.state?.newProject;

        if (this.state.sessionTerminated) {
            return <Redirect to={{ pathname: '/auth/logout' }} />;
        }

        if (this.state.redirect) {
            return <Redirect to="/admin/projects" />;
        }

        if (this.state.formValid === true) {
            if (this.props.mainPanel) {
                this.props.mainPanel.current.scrollTop = 0;
            }

            const redirectState = newProject
                ? {
                    pathname: '/admin/viewProject',
                    state: {
                        id: this.state.createdProjectId,
                        projectName: this.state.createdProjectName,
                        editable: true
                    }
                }
                : {
                    pathname: '/admin/viewProject',
                    state: {
                        id: this.state.updatedProjectId,
                        projectName: this.state.projectName,
                        editable: true
                    }
                };

            return <Redirect to={redirectState} />;
        }

        const stepLabels = [
            t('project:projectInformation'),
            t('project:currentAnalysis'),
            t('project:historicalAnalysis')
        ];

        // Step props
        const step1Props = {
            projectName: this.state.projectName,
            projectTeam: this.state.projectTeam,
            userOptions: this.state.userOptions,
            handleProjectNameUpdate: this.handleProjectNameUpdate,
            handleProjectTeamUpdate: this.handleProjectTeamUpdate,
            applicationSelected: this.state.applicationSelected,
            moduleSelected: this.state.moduleSelected,
            applicationOptions: this.state.applicationOptions,
            moduleOptions: this.state.moduleOptions,
            userAttributeFilters: this.state.userAttributeFilters,
            handleApplicationsOnChange: this.handleApplicationsOnChange,
            handleApplicationsInputChange: this.handleApplicationsInputChange,
            handleModulesOnChange: this.handleModulesOnChange,
            handleModulesInputChange: this.handleModulesInputChange,
            handleUserAttributesUpdate: this.handleUserAttributesUpdate,
            resetOptions: this.resetOptions,
            annualFTECost: this.state.annualFTECost,
            annualFTEHours: this.state.annualFTEHours,
            LTNonError: this.state.LTNonError,
            LTSysError: this.state.LTSysError,
            LTUserError: this.state.LTUserError,
            LTUncatMessage: this.state.LTUncatMessage,
            projectDuration: this.state.projectDuration,
            projectUser: this.state.projectUser,
            testEffortPerModule: this.state.testEffortPerModule,
            formErrors: this.state.formErrors,
            inputClass_annualFTECost: this.state.inputClass_annualFTECost,
            inputClass_annualFTEHours: this.state.inputClass_annualFTEHours,
            inputClass_LTNonError: this.state.inputClass_LTNonError,
            inputClass_LTSysError: this.state.inputClass_LTSysError,
            inputClass_LTUserError: this.state.inputClass_LTUserError,
            inputClass_LTUncatMessage: this.state.inputClass_LTUncatMessage,
            inputClass_projectDuration: this.state.inputClass_projectDuration,
            inputClass_projectUser: this.state.inputClass_projectUser,
            inputClass_testEffortPerModule: this.state.inputClass_testEffortPerModule,
            handleInputChange: this.handleInputChange
        };

        const step2Props = {
            timeFilter: this.state.timeFilter,
            handleTimeFilterUpdate: this.handleTimeFilterUpdate,
            projects: this.state.workbooks.currentReportArray,
            selectedProjects: this.state.workbooks.currentSelectedProjects,
            handleProjectReportsUpdate: this.handleProjectReportsUpdate,
            selectAllHandler: this.selectAllHandler,
            isSelectAllChecked: this.state.isSelectAllCheckedCurrent,
            resetSelectAllCheckStatus: this.resetSelectAllCheckStatus,
            absoluteStartError: this.state.absoluteStartErrorCurrent,
            absoluteEndError: this.state.absoluteEndErrorCurrent
        };

        const step3Props = {
            timeFilter: this.state.timeFilter,
            handleTimeFilterUpdate: this.handleTimeFilterUpdate,
            projects: this.state.workbooks.historicalReportArray,
            selectedProjects: this.state.workbooks.historicalSelectedProjects,
            handleProjectReportsUpdate: this.handleProjectReportsUpdate,
            selectAllHandler: this.selectAllHandler,
            isSelectAllChecked: this.state.isSelectAllCheckedHistorical,
            resetSelectAllCheckStatus: this.resetSelectAllCheckStatus,
            absoluteStartError: this.state.absoluteStartErrorHistorical,
            absoluteEndError: this.state.absoluteEndErrorHistorical
        };

        const footerObj = [
            {
                name: t('common:save'),
                callback: this.handleClickSave
            }
        ];

        return (
            <>
                <div className="main-content main-content-page-with-footer project-wizard-main-content">
                    <Helmet>
                        <title>
                            {newProject
                                ? 'Knoa Analytics - New Project'
                                : 'Knoa Analytics - Edit Project'}
                        </title>
                    </Helmet>

                    <Row className="user-admin-breadcrumb">
                        <KnoaBreadcrumb
                            href="#/admin/projects"
                            firstLevelText={t('route.name:Projects')}
                            secondLevelText={
                                newProject
                                    ? t('route.name:New Project')
                                    : t('route.name:Edit Project')
                            }
                        />
                    </Row>

                    {this.state.showLoggedoutModal && (
                    <ModalDialog
                        showModal={this.state.showLoggedoutModal}
                        modalID="mProWizLogOut"
                        title="Log Out"
                        contentBody={
                            <span>
                                {getSpecificOPErrorMessages(this.props.t, 'logoutfor401')}
                            </span>
                        }
                        bodyPaddingBottom="15px"
                        footerBtnBsStyle="success"
                        footerBtnClass="KnoaSuccessButton"
                        footerBtnOnClick={this.handleLogoutConfirm}
                        footerBtnText={t('common:ok')}
                    />
                    )}

                    {this.state.fetchInProgress === 'true' && <Spinner />}

                    <div hidden={this.state.fetchInProgress === 'true'}>
                        <CommonContainer className="common-page-content-row user-profile-rule">
                            <Col className="knoa-region" tabIndex="-1">
                                <Card
                                    wizard
                                    id="projectWizardCard"
                                    textCenter
                                    title={t('project:projectSetup')}
                                    content={
                                        <Wizard>
                                            <ProjectStep1 {...step1Props} stepLabels={stepLabels} />
                                            <ProjectStep2 {...step2Props} stepLabels={stepLabels} />
                                            <ProjectStep3 {...step3Props} stepLabels={stepLabels} />
                                        </Wizard>
                                    }
                                />
                            </Col>
                        </CommonContainer>
                    </div>
                </div>
                <Footer fluid footerObj={footerObj} />
            </>
        );
    }
}

export default withTranslation()(ProjectWizard);
